// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDX4rQsLl9QNGU32zNvRT2efqnL0ILgY10",
  authDomain: "project-9067071027250667586.firebaseapp.com",
  projectId: "project-9067071027250667586",
  storageBucket: "project-9067071027250667586.appspot.com",
  messagingSenderId: "904034447569",
  appId: "1:904034447569:web:28c735a3dd908fb0f315f0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app)

export { db }